export default {
  name: 'evaluate-question-check',
  created () {
    this.search(false)
  },
  data () {
    return {
      normalQuestions: [],
      personnelQuestions: [],
      businessQuestions: [],
      getQuestionsEnd: false
    }
  },
  computed: {
  },
  methods: {
    async search () {
      let data = {
        id: this.$route.params.id
      }
      let res = await this.$store.dispatch('EVALUATE_ANSWER_ANSWER_DETAIL_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.normalQuestions = res.evaluate_normal_answer
      this.personnelQuestions = res.evaluate_personal_answer.data.map(answer => {
        return {
          id: parseInt(answer.id),
          answer_content: answer.attributes['answer-content'],
          display_order: answer.attributes['display-order'],
          evaluate_answer_id: answer.attributes['evaluate-answer-id'],
          question_content: answer.attributes['question-content'],
          word: answer.attributes.word
        }
      })
      this.businessQuestions = res.evaluate_business_answer.data.map(answer => {
        return {
          id: parseInt(answer.id),
          answer_content: answer.attributes['answer-content'],
          display_order: answer.attributes['display-order'],
          evaluate_answer_id: answer.attributes['evaluate-answer-id'],
          question_content: answer.attributes['question-content'],
          word: answer.attributes.word
        }
      })
      this.getQuestionsEnd = true
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question-check.js